import OwlCarousel from 'react-owl-carousel3';
import { Link } from "react-router-dom";

const Banner = (Props) => {
    return (
        <OwlCarousel className="owl-carousel owl-theme" {...Props.options}>
            {Props.data.map((item, index) => {
                if (item.banner_type === 'video') {
                    return (
                        <video key={index} width="100%" height={487} controls>
                            <source src={item.file} type="video/mp4" />
                            <source src={item.file} type="video/ogg" />
                            <source src={item.file} type="video/webm" />
                        </video>
                    );
                }

                const imageSrc = item.file || item.image || item.logo;
                const hasLink = !!item.banner_for_id || !!item.slug;
                let toUrl = "";

                if (hasLink) {
                    if (Props.type === 'Banner' || Props.type === 'sale') {
                        toUrl = `/product/${item.type !== "product" ? item.type : "product-detail"}/${item.banner_for_id}`;
                    } else if (Props.type === 'top_brand') {
                        toUrl = `/brand/${item.slug}`;
                    } else if (Props.type === 'brand') {
                        toUrl = `/${Props.type}/${item.slug}`;
                    } else {
                        toUrl = `/product/${Props.type}/${item.banner_for_id}`;
                    }
                }

                const picture = (
                    <picture>
                        <source media="(min-width:575.98px)" srcSet={imageSrc} />
                        <img src={imageSrc} alt={imageSrc} />
                    </picture>
                );

                return (
                    <div className="item" key={index}>
                        <div className="banner-img">
                            {hasLink ? <Link to={toUrl}>{picture}</Link> : picture}
                        </div>
                    </div>
                );
            })}
        </OwlCarousel>
    );
};

export default Banner;
